/** A refusal or a missing request answers the same on every retry. */
export function isPermanentFailureStatus(status) {
    return status === 403 || status === 404;
}
